import { PROSPECT_ENDPOINTS } from '../../../utils/api/endpoints/prospectEndpoints';
import { UseDIRProspectsQueryParams, UseDIRProspectsResponse } from './useDIRProspects.types';

const PREFIX = '[prospectsDIRQuery]';

export const queryAllDIRProspects = async (params: UseDIRProspectsQueryParams) => {
  console.log(PREFIX, `Fetching prospects DIR...`);
  const response = await PROSPECT_ENDPOINTS.getAllFromDIR(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received prospects DIR.`);
  return json as UseDIRProspectsResponse;
};
